
 import Vue from "vue";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import HC_sankey from "highcharts/modules/sankey";
import dependencywheel from "highcharts/modules/dependency-wheel";
HC_sankey(Highcharts);
dependencywheel(Highcharts);
import axios from "axios";
import API from "../service/config";
import { post, fetch, patch, put, toDelete } from "../service/http-service";
import { Loading } from "element-ui";

export default Vue.extend({
  name: "HighCharts",
  components: {
    highcharts: Chart,
  },
  props: ["datasetId"],
  data() {
    return {
      chartOptions: {},
      sample: "",
      sampleData: [],
      id: "",
    };
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.getSampleData();
    //this.getJSONData();
  },

  methods: {
    getSampleData() {
      fetch(
        API.domainUrl + API.exploreGetSampleBy + "?dataset=" + this.id
      ).then((response: any) => {
        this.sampleData = response.data.sample;
        this.sample = this.sampleData[0];
        this.getJSONData();
      });
    },
    getJSONData() {
      let loadingInstance = Loading.service({});
      post(API.domainUrl + API.exploreGetDataBy, {
        sample: this.sample,
        dataset: this.datasetId,
      }).then((response: any) => {
        if (response.status.code == 200) {
          loadingInstance.close();
          let myData = response.data.data;

          this.chartOptions = {
            title: {
              text: "",
            },
            credits: {
              enabled: false,
            },
            series: [
              {
                keys: ["from", "to", "weight"],
                data: myData,
                type: "dependencywheel",
                name: "Dependency wheel series",
                dataLabels: {
                  color: "#333",
                  allowOverlap: false,
                  textPath: {
                    enabled: false,
                    attributes: {
                      dy: 5,
                    },
                  },
                  distance: 10,
                },
                size: "95%",
              },
            ],
          };
        } else {
          loadingInstance.close();
          this.$message.error(response.status.msg);
        }
      });
    },
    selectSample(sample: string) {
      this.sample = sample;
      this.getJSONData();
    },
  },

});

